import { FilterFields } from 'shared/mui/Filter/FilterFields/FilterFields';

import { useBankOperationsFilterFields } from './hooks/useBankOperationsFilterFields';

export const BankOperationsFilterForm: React.FC = () => {
  const fields = useBankOperationsFilterFields();

  return <FilterFields fields={fields} />;
};
